module.exports = __webpack_public_path__ + "static/media/road.6c19bca1.jpg";